module.exports = __webpack_public_path__ + "static/machine04-e50859a17be8550582977158ad1509fe.png";